import React, { Component } from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';
import PropTypes from 'prop-types';
import { withPrefix, Link } from 'gatsby';
import ReactMarkdown from 'react-markdown';
import Glide from '@glidejs/glide';
import ArrowIcon from './ArrowIcon';
import ChevronLeftIcon from '../misc/ChevronLeftIcon';
import ChevronRightIcon from '../misc/ChevronRightIcon';

// import glidejs styles
import '@glidejs/glide/src/assets/sass/glide.core.scss';
import '@glidejs/glide/src/assets/sass/glide.theme.scss';


/* OLD CONTENT */
// <div className="headline-container">
//   <ReactMarkdown source={ props.header.headline } escapeHtml={false} />
//   <ReactMarkdown source={ props.header.subtext } />
//   <OutboundLink href="https://register.presono.com"  className="button is-rounded teaser-button"><ArrowIcon fill="#fff" />
//     <span>{ props.header.buttonText }</span></OutboundLink>
// </div>
//
// <div className="video-container">
//   <img src="/img/messe-header.jpg" alt="Photo Entrance 2 Minuten 2 Millionen"></img>
//   {/* <video width="1280" height="720" autoPlay="autoplay" loop="loop" muted="muted" poster={withPrefix('/video/header.jpg')}>
//     <source src={withPrefix('/video/header.webm')} type="video/webm" />
//     <source src={withPrefix('/video/header.mp4')} type="video/mp4"/>
//     <source src={withPrefix('/video/header.ogv')} type="video/ogv" />
//     <p>Your browser does not support the video tag.</p>
//   </video> */}
// </div>
//
// <aside className="aside">
//   {/* <h2>{ props.locale === "en" ? "Solutions for your purpose!" : "Die Lösung für Ihren Einsatzzweck!" } </h2> */}
//   <h2>{ props.locale === "en" ? "Now compensate for unusual trade fairs with our digital trade fair presence!" :
//     "Jetzt mit unserem digitalen Messe-Auftritt ausgefallene Messen kompensieren!"}</h2>
//
//   <div className="btn more" >
//     <Link to={ props.locale === "en" ? "/blog/en/presono-helps-companies-in-corona-crisis/" : "/blog/de/presono-hilft-unternehmen-in-corona-krise/"}>
//         <ArrowIcon fill="#34BFC9" /> <span>{ props.locale === "en" ? "More Info" : "Mehr Infos"}</span>
//     </Link>
//   </div>
//
//   {/* <div className="btn unternehmen" >
//     <Link to={ props.locale === "en" ? "/solutions/en/company" : "/solutions/de/company"}>
//         <ArrowIcon fill="#34BFC9" /> <span>{ props.header.aside1 }</span>
//     </Link>
//   </div>
//   <div className="btn produkte" >
//     <Link to={ props.locale === "en" ? "/solutions/en/products" : "/solutions/de/products"}>
//       <ArrowIcon fill="#34BFC9" /> <span>{ props.header.aside2 }</span>
//     </Link>
//   </div>
//   <div className="btn vertrieb" >
//     <Link to={ props.locale === "en" ? "/solutions/en/sales" : "/solutions/de/sales"}>
//       <ArrowIcon fill="#34BFC9" /> <span>{ props.header.aside3 }</span>
//     </Link>
//   </div>
//   <div className="btn messen">
//     <Link to={ props.locale === "en" ? "/solutions/en/fairs" : "/solutions/de/fairs"} >
//       <ArrowIcon fill="#34BFC9" /> <span>{ props.header.aside4 }</span>
//     </Link>
//   </div> */}
// </aside>

export default class Teaser extends Component {
  static propTypes = {
    header: PropTypes.object,
  }

  componentDidMount() {
    const { header } = this.props;
    if (header && header.headlineCarousel) this.mountGlide();
  }

  componentDidUpdate(prevProps) {
    const prevHeader = prevProps.header;
    const { header } = this.props;
    if (
      (!prevHeader || !prevHeader.headlineCarousel)
      && (header && header.headlineCarousel)
    ) {
      this.mountGlide();
    }
  }

  mountGlide = () => {
    new Glide('.glide', {
      type: 'carousel',
      autoplay: 5000,
    }).mount();
  }

  render() {
    const { header } = this.props;
    return (
      <header>
        <div className="mainSection">
          {
            header && header.headlineCarousel && (
              <div className="glide">
                <div className="glide__track" data-glide-el="track">
                  <ul className="glide__slides">
                    { header.headlineCarousel.map(item => (
                      <li className="glide__slide">
                        {item.carouselImage && !(item.carouselVideoMp || item.carouselVideoWebm) && (
                          <img src={`/img/${item.carouselImage.relativePath}`} alt={item.carouselHeadline} />
                        )}
                        {(item.carouselVideoMp || item.carouselVideoWebm) && (
                          <video width="1280" height="720" autoPlay="autoplay" loop="loop" muted="muted" poster={withPrefix(`/img/${item.carouselImage.relativePath}`)}>
                            {item.carouselVideoWebm && <source src={withPrefix(`/img/${item.carouselVideoWebm.relativePath}`)} type="video/webm" />}
                            {item.carouselVideoMp && <source src={withPrefix(`/img/${item.carouselVideoMp.relativePath}`)} type="video/mp4" />}
                            <p>Your browser does not support the video tag.</p>
                          </video>
                        )}

                        <div className="shade" />

                        {(item.carouselHeadline || item.carouselSubtext || (item.carouselButtonText && item.carouselButtonLink)) && (
                          <div className="headline-container">
                            { item.carouselHeadline && <ReactMarkdown source={item.carouselHeadline} escapeHtml={false} />}
                            { item.carouselSubtext && <ReactMarkdown source={item.carouselSubtext} escapeHtml={false} />}
                            { (item.carouselButtonText && item.carouselButtonLink) && !item.carouselButtonLink.startsWith('/') && (
                              <OutboundLink
                                href={item.carouselButtonLink}
                                className="button is-rounded teaser-button"
                                target="_blank"
                                rel={item.carouselButtonLink.includes('presono.com') ? '' : 'noopener noreferrer'}
                              >
                                <ArrowIcon fill="#fff" />
                                <span>{ item.carouselButtonText }</span>
                              </OutboundLink>
                            )}
                            { (item.carouselButtonText && item.carouselButtonLink) && item.carouselButtonLink.startsWith('/') && (
                              <Link
                                to={item.carouselButtonLink}
                                className="button is-rounded teaser-button"
                              >
                                <ArrowIcon fill="#fff" />
                                <span>{ item.carouselButtonText }</span>
                              </Link>
                            )}
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="glide__arrows" data-glide-el="controls">
                  <button className="glide__arrow glide__arrow--left" type="button" data-glide-dir="<"><ChevronLeftIcon /></button>
                  <button className="glide__arrow glide__arrow--right" type="button" data-glide-dir=">"><ChevronRightIcon /></button>
                </div>
                <div className="glide__bullets" data-glide-el="controls[nav]">
                  { header.headlineCarousel.map((_, i) => (
                    <button className="glide__bullet" type="button" data-glide-dir={`=${i}`} />
                  ))}
                </div>
              </div>
            )
          }
        </div>
      </header>
    );
  }
}
